var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{staticClass:"view-global-footer",class:_vm.className,attrs:{"id":"globalFooter"}},[(_vm.config.App.ENABLE_LANGUAGE)?_c('ViewButtonSelectLanguage'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }